import { ADMIN_DASHBOARD_ERROR, GETTING_ADMIN_DASHBOARD_DATA, GET_ADMIN_DASHBOARD_DATA } from "../types"

const initialState = {
    adminDashboardData: null,
    loadingAdminDashboard: true,
    adminDashboardError: null,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){
    switch(action.type){
        case GETTING_ADMIN_DASHBOARD_DATA:
        return {
            ...state,
            loadingAdminDashboard: action.payload,
        }
        case GET_ADMIN_DASHBOARD_DATA:
        return{
            ...state,
            loadingAdminDashboard: false,
            adminDashboardError: null,
            adminDashboardData: action.payload,
        }
        case ADMIN_DASHBOARD_ERROR:
        return{
            ...state,
            loadingAdminDashboard: false,
            adminDashboardError: action.payload
        }
        default: return state
    }
}
